import axios from "axios";
import jwtService from "@service/jwt-service";
import { commonNotify } from "@utils/common";
import { CommonConst } from "@constants/common-const";

/**
 * S3 Presigned Url 생성 요청
 */
export async function getFileUrl(filePurpose: string, fileType: string, fileName: string) {
  // store.commit("store/setLoading", true);
  let params = null;
  let result = null;
  let s3Model = null;

  try {
    params = `filetype=${fileType}&filename=${fileName}`;
    result = await jwtService.getFileUrl(filePurpose, params);

    s3Model = result.data;
  } catch (e) {
    commonNotify(CommonConst.errorCommon, "error");
  } finally {
    // store.commit("store/setLoading", false);
  }
  return s3Model;
}

/**
 * S3 Presigned Url 다중 생성 요청
 */
export async function getFileUrls(fileType: string, fileName: string) {
  // store.commit("store/setLoading", true);
  let params = null;
  let result = null;
  let s3Model = null;

  try {
    params = `filetype=${fileType}&filename=${fileName}`;
    result = await jwtService.getFileUrls(params);

    s3Model = result.data;
  } catch (e) {
    commonNotify(CommonConst.errorCommon, "error");
  } finally {
    // store.commit("store/setLoading", false);
  }
  return s3Model;
}

/**
 * S3 Presigned Url을 통한 파일 업로드
 */
export async function saveFile(requestHeaders: any, url: string, file: any) {
  // store.commit("store/setLoading", true);

  try {
    await axios({
      method: "put",
      url,
      data: file,
      headers: requestHeaders,
    });
  } catch (e) {
    console.log(e);
    commonNotify(CommonConst.errorCommon, "error");
  } finally {
    // store.commit("store/setLoading", false);
  }
}
